"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptanceRefusedError = void 0;
/**
 * Wraps a refused acceptance response so it can be thrown: every caller of the create-account
 * SDK methods (`Register.tsx` and friends) wraps the call in try/catch and reads
 * `error.response.data`, matching the shape Axios would give for a thrown HTTP error.
 */
class AcceptanceRefusedError extends Error {
    constructor(response) {
        super(response.data.message);
        this.name = "AcceptanceRefusedError";
        this.response = response;
    }
}
exports.AcceptanceRefusedError = AcceptanceRefusedError;
//# sourceMappingURL=AcceptanceRefusedError.js.map